(function() {
    /* jshint validthis: true */
    "use strict";
    
    var lang = lang || document.documentElement.lang;
    var dates;
    
    function statusInput(e) {
        var inp = e ? e.target : this;
        
        if (inp.value.trim() !== "") {
            if (!hasClass("disabled") && !inp.disabled) {
                addClass(inp, "filled");
                removeClass(inp, "alert");
            }
        } else {
            removeClass(inp, "filled");
            if (hasClass(inp, "required")) {
                addClass(inp, "alert");
            } else {
                removeClass(inp, "alert");
            }
        }
    }
    
    function checkFilledInput() {
        var inp = this;
        // Add filled class if the value is not empty
        if (inp.value.trim() !== "") {
            if (!hasClass("disabled") && !inp.disabled) {
                addClass(inp, "filled");
                removeClass(inp, "alert");
            }
        }
        // Init the event
        bindEvent(inp, "input", statusInput);
    }
    
    function openFileBrowser(e) {
        var targ = qs(".inp-file", getAncestor(this, "inp-file-ctn"));
        targ.click();
    }
    function changeFileName(e) {
        var file = e.target.files[0];
        if (verifyFileType(file)) {
            qs(".inp-file-holder", getAncestor(e.target, "inp-file-ctn")).value = file.name;
        } else {
            qs(".inp-file-holder", getAncestor(e.target, "inp-file-ctn")).value = "";
            e.target.value = "";
        }
    }
    
    function toggleElementOn(e) {
        var targ = e.currentTarget || e.target;
        var el = qs(".el-to-toggle", getAncestor(targ, "el-toggle-ctn"));
        var inp = hasClass(el, "el-to-toggle-input") ? el : qs(".el-to-toggle-input", el);
        
        if (inp && hasClass(inp, "derequired")) {
            addClass(inp, "required");
        }
        $(el).slideDown(300);
    }
    function toggleElementOff(e) {
        var targ = e.currentTarget || e.target;
        var el = qs(".el-to-toggle", getAncestor(targ, "el-toggle-ctn"));
        var inp = hasClass(el, "el-to-toggle-input") ? el : qs(".el-to-toggle-input", el);
        
        if (inp && hasClass(inp, "derequired")) {
            removeClass(inp, "required");
        }
        $(el).slideUp(300);
    }

    function DisableDates(date) {
        var string = jQuery.datepicker.formatDate('dd/mm/yy', date);
        return [dates.indexOf(string) === -1];
    }
    
    function datetimepickerDecompose(date, $input) {
        if (!DisableDates(date)[0]) {
            $input.datetimepicker("reset");
            return false;
        }
        
        var $wrap = $input.parents(".datetimepicker-wrap");
        if (date) {
            $wrap.find(".datetimepicker-dy").val(date.getFullYear());
            $wrap.find(".datetimepicker-dm").val(date.getMonth());
            $wrap.find(".datetimepicker-dd").val(date.getDate());
            $wrap.find(".datetimepicker-th").val(date.getHours());
            $wrap.find(".datetimepicker-tm").val(date.getMinutes());
            $wrap.find(".datetimepicker-ts").val(date.getSeconds());
        } else {
            $wrap.find(".datetimepicker-dy").val("");
            $wrap.find(".datetimepicker-dm").val("");
            $wrap.find(".datetimepicker-dd").val("");
            $wrap.find(".datetimepicker-th").val("");
            $wrap.find(".datetimepicker-tm").val("");
            $wrap.find(".datetimepicker-ts").val("");
        }
    }

    // Pre-initiate
    DOMInit("interactive", function(e) {
        each(qsa(".inp-txt, .inp-txta, .inp-sel"), function(el) {
            checkFilledInput.call(el);
        });
        
        // File input events
        bindEvent(".inp-file-btn", "click", openFileBrowser);
        bindEvent(".inp-file", "change", changeFileName);
        
        // Toggle events
        bindEvent(".el-toggle-check-on", "change", toggleElementOn);
        bindEvent(".el-toggle-check-off", "change", toggleElementOff);
        
        // Init date picker
        if ($.datepicker) {
            $(".datepicker").datepicker();
            $.datepicker.regional["en-CA"] = {
                dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
                dateFormat: "MM dd, yy"
            };
            $.datepicker.setDefaults($.datepicker.regional["en-CA"]);
        }

        //TEMPORAIRE : QUICK FIX POUR LE CLIENT
        // dates = ["23/06/2021", "24/06/2021", "25/06/2021"];
        
        if($('input[name=globalBlockedDates]').val()) {
            dates = ($('input[name=globalBlockedDates]').val().toString()).split(',');
        }
        else {
            dates = [];
        }

        // Init datetime picker
        if ($.datetimepicker) {
            $(".datetimepicker").each(function () {
                var $it = $(this);
                var options = {
                    format: "d/m/Y H:i",
                    minDate: 0,
                    step: 5,
                    lang: lang,
                    onChangeDateTime: datetimepickerDecompose,
                    disabledDates: dates, beforeShowDay: DisableDates //TEMPORAIRE : QUICK FIX POUR LE CLIENT
                };
                
                if ($it.hasClass("date-only")) {
                    options.timepicker = false;
                    options.format = "d/m/Y";
                } else if ($it.hasClass("time-only")) {
                    options.datepicker = false;
                    options.format = "H:i";
                    options.minDate = false;
                }
                $it.datetimepicker(options);
                // Bind showing picker on the icon
                $it.parents(".datetimepicker-wrap").find("svg").on("click", function() {
                    $it.datetimepicker("show");
                });
            });
        }
    });

})();